import tooltipInfo from '../../utils/tooltipInfo.json';

const AddParticipantFormDataConfig = [
  {
    key: 'participantType',
    label: 'Participant Type',
    defaultValue: '',
    type: 'radio',
    size: 12,
    values: [
      { label: 'Customer', value: 'CUSTOMER' },
      { label: 'Provider', value: 'PROVIDER' },
      { label: 'Aggregator', value: 'AGGREGATOR' },
      { label: 'Customer Aggregator', value: 'CUSTOMER_AGGREGATOR' }
    ],
    rules: {
      validate: (value: any) => {
        return value ? null : 'Please select Participant Type';
      }
    }
  },
  {
    key: 'participantCode',
    label: 'Participant ID',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: true,
    placeholder: 'Enter Name',
    rules: {
      required: {
        value: true,
        message: 'Participant Name is Required'
      },
      minLength: {
        value: 3,
        message: 'Participant Name must be atleast 5 characters'
      }
    },
    tooltip: tooltipInfo.participantId
  },
  {
    key: 'companyName',
    label: 'Company Name',
    defaultValue: '',
    type: 'text',
    size: 6,
    required: true,
    placeholder: 'Enter Company Name',
    rules: {
      required: {
        value: true,
        message: 'Company Name is Required'
      }
    },
    tooltip: tooltipInfo.companyName
  },
  {
    key: 'primaryEmail',
    label: 'Primary Email',
    defaultValue: '',
    type: 'email',
    size: 6,
    required: false,
    placeholder: 'Enter Email Address',
    rules: {
      required: {
        value: true,
        message: 'Email is Required'
      },
      pattern: {
        value: /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
        message: 'Invalid email address'
      }
    },
    tooltip: tooltipInfo.primaryEmail
  },
  {
    key: 'isAdditionalParametersRequired',
    label: 'Is Client Specific Authentication Required',
    defaultValue: 'no',
    type: 'radio',
    size: 12,
    values: [
      { label: 'Yes', value: 'yes' },
      { label: 'No', value: 'no' }
    ],
    tooltip: tooltipInfo.clientAuth
  }
];

export const ParameterTypeConfig = [
  {
    label: 'Authentication Header',
    value: 'authHeaders'
  },
  {
    label: 'Form Parameter',
    value: 'formParams'
  },
  {
    label: 'Request Header',
    value: 'requestHeaders'
  },
  {
    label: 'Authentication',
    value: 'primary'
  },
  {
    label: 'Request Body',
    value: 'authBodyParameters'
  }
];

export const PrimaryParamterConfig = [
  {
    label: 'Identifier',
    value: 'identifier'
  },
  {
    label: 'Secret',
    value: 'secret'
  },
  {
    label: 'Auth Url',
    value: 'authUrl'
  }
];

export const ClientPrimaryCredsConfig = [
  {
    label: 'Client Id',
    value: 'clientId'
  },
  {
    label: 'Secret',
    value: 'secret'
  }
];

export default AddParticipantFormDataConfig;
